"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = require("prop-types");

var _react = _interopRequireWildcard(require("react"));

var _label = _interopRequireDefault(require("@ingka/label"));

var _button = _interopRequireDefault(require("@ingka/button"));

var _classnames = _interopRequireDefault(require("classnames"));

var _visibilityHide = _interopRequireDefault(require("@ingka/ssr-icon/paths/visibility-hide"));

var _visibilityShow = _interopRequireDefault(require("@ingka/ssr-icon/paths/visibility-show"));

var _ssrIcon = _interopRequireDefault(require("@ingka/ssr-icon"));

var _formFieldStatus = _interopRequireDefault(require("@ingka/form-field-status"));

var _excluded = ["prefix", "type", "label", "placeholder", "req", "inputMode", "disabled", "hidePasswordText", "showPasswordText", "className", "prefixLabel", "suffixLabel", "id", "describedById", "ssrIcon", "iconPosition", "iconOnClick", "iconClickDescription", "onChange", "characterLimit", "helper", "validation", "shouldValidate", "valid"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var InputField = (0, _react.forwardRef)(function (props, ref) {
  var prefix = props.prefix,
      type = props.type,
      label = props.label,
      placeholder = props.placeholder,
      req = props.req,
      inputMode = props.inputMode,
      disabled = props.disabled,
      hidePasswordText = props.hidePasswordText,
      showPasswordText = props.showPasswordText,
      className = props.className,
      prefixLabel = props.prefixLabel,
      suffixLabel = props.suffixLabel,
      id = props.id,
      describedById = props.describedById,
      ssrIcon = props.ssrIcon,
      iconPosition = props.iconPosition,
      iconOnClick = props.iconOnClick,
      iconClickDescription = props.iconClickDescription,
      onChange = props.onChange,
      characterLimit = props.characterLimit,
      helper = props.helper,
      validation = props.validation,
      shouldValidate = props.shouldValidate,
      valid = props.valid,
      other = _objectWithoutProperties(props, _excluded);

  var togglePasswordVisibility = function togglePasswordVisibility(e) {
    e.preventDefault();
    setPasswordVisible(!passwordVisible);
  };

  var onChangeHandler = function onChangeHandler(e) {
    if (value === null || value === undefined) {
      setCharacterCount(e.target.value.length);
    }

    setLabelled(e.target.value !== '');

    if (onChange) {
      onChange(e);
    }
  };

  var value = other.value,
      defaultValue = other.defaultValue;
  var defaultCharacterCount = 0;
  var defaultLabelled = false;

  if (value || value === 0) {
    defaultCharacterCount = value.length;
    defaultLabelled = value === 0 || value;
  } else if (defaultValue || defaultValue === 0) {
    defaultLabelled = defaultValue === 0 || defaultValue;
    defaultCharacterCount = defaultValue.length;
  }

  var _useState = (0, _react.useState)(defaultCharacterCount),
      _useState2 = _slicedToArray(_useState, 2),
      characterCount = _useState2[0],
      setCharacterCount = _useState2[1];

  var _useState3 = (0, _react.useState)(defaultLabelled),
      _useState4 = _slicedToArray(_useState3, 2),
      labelled = _useState4[0],
      setLabelled = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      passwordVisible = _useState6[0],
      setPasswordVisible = _useState6[1];

  (0, _react.useEffect)(function () {
    setLabelled(defaultLabelled);
  }, [defaultLabelled]);
  (0, _react.useEffect)(function () {
    setCharacterCount(defaultCharacterCount);
  }, [defaultCharacterCount]);
  var trailing = type === 'password' || iconPosition === 'trailing';
  var baseClass = "".concat(prefix, "input-field");
  var classes = (0, _classnames.default)("".concat(baseClass), prefixLabel && "".concat(baseClass, "--prefixed"), suffixLabel && "".concat(baseClass, "--suffixed"), iconPosition === 'leading' && "".concat(baseClass, "--leading-icon"), trailing && "".concat(baseClass, "--trailing-icon"), labelled && "".concat(baseClass, "--labelled"), shouldValidate && !valid && "".concat(baseClass, "--error"), shouldValidate && valid && "".concat(baseClass, "--success"), className);
  var convertedType = type === 'number' ? 'text' : type;
  return _react.default.createElement("div", {
    className: classes
  }, _react.default.createElement("div", {
    className: "".concat(baseClass, "__wrapper")
  }, _react.default.createElement("input", _extends({
    ref: ref,
    type: passwordVisible ? 'text' : convertedType,
    id: id,
    disabled: disabled,
    required: req
  }, other, {
    onChange: onChangeHandler,
    inputMode: type === 'number' ? 'numeric' : inputMode,
    "aria-describedby": describedById,
    "aria-required": Boolean(req),
    "aria-invalid": shouldValidate ? !valid : null
  })), iconPosition === 'leading' && ssrIcon && _react.default.createElement(_ssrIcon.default, {
    prefix: prefix,
    paths: ssrIcon
  }), prefixLabel && _react.default.createElement("span", {
    className: "".concat(baseClass, "__prefix-label")
  }, prefixLabel), _react.default.createElement(_label.default, {
    title: label,
    prefix: prefix,
    htmlFor: id,
    label: label
  }), suffixLabel && _react.default.createElement("span", {
    className: "".concat(baseClass, "__suffix-label")
  }, suffixLabel), type === 'password' && _react.default.createElement(_button.default, {
    htmlType: "button",
    prefix: prefix,
    iconOnly: true,
    xsmallIconOnly: true,
    ssrIcon: passwordVisible ? _visibilityHide.default : _visibilityShow.default,
    onClick: togglePasswordVisibility,
    type: "plain",
    text: passwordVisible ? hidePasswordText : showPasswordText,
    disabled: disabled
  }), iconPosition === 'trailing' && ssrIcon && _react.default.createElement(_button.default, {
    htmlType: "button",
    prefix: prefix,
    xsmallIconOnly: true,
    ssrIcon: ssrIcon,
    iconOnly: true,
    onClick: iconOnClick ? iconOnClick : null,
    type: "plain",
    text: iconClickDescription,
    disabled: disabled
  }), _react.default.createElement("span", {
    className: "".concat(baseClass, "__divider")
  })), (characterLimit > 0 || validation || helper) && _react.default.createElement(_formFieldStatus.default, {
    prefix: prefix,
    characterCount: characterLimit > 0 ? characterCount : null,
    characterLimit: characterLimit > 0 ? characterLimit : null,
    disabled: disabled,
    shouldValidate: shouldValidate,
    valid: valid,
    helper: helper,
    validation: validation
  }));
});
InputField.defaultProps = {
  prefix: '',
  type: 'text',
  label: '',
  req: false,
  disabled: false,
  hidePasswordText: 'Hide password',
  showPasswordText: 'Show password'
};
var _default = InputField;
exports.default = _default;